import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { StateService } from '@uirouter/angular';
import { AlertAndNotificationsService } from 'src/app/core/services/alert-and-notifications.service';
import { AuthService } from 'src/app/core/services/auth.service';
import { JobService } from 'src/app/core/services/job.service';
import { StateManagementStorageService } from 'src/app/core/services/state-management-storage.service';
import { StorageService } from 'src/app/core/services/storage.service';
import { UserService } from 'src/app/core/services/user.service';

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html'
})
export class UsersComponent implements OnInit {

  @Input() iconClicked: any;
  @Input() managerDetails: any;
  @Input() fromManagerCard: boolean;

  @Input() managers: any[] = [];
  @Output() managersChange = new EventEmitter<any[]>();

  @Input() currentManager: any;
  @Output() currentManagerChange = new EventEmitter<any>();

  userDetails: any = {};
  userDetailsCopy: any = {};
  teamMemberData: any[] = [];
  activityMap: any[] = [];
  rowViewUserData: any[] = [];
  rowViewUserDataOriginal: any[] = [];
  teamMemberLoaded: boolean = false;
  fromUserManagement: boolean = false;
  companyState: string;
  userId: any;
  addUserNotEnabled: boolean = true;
  isCollapsed: boolean = true;
  isUserRowViewActive: boolean = false;
  searchTerm: string = '';
  skeletonPlaceholders = Array(6).fill(0);

  constructor(
    private authService: AuthService,
    private userService: UserService,
    private jobService: JobService,
    private alertsAndNotificationsService: AlertAndNotificationsService,
    private storageService: StorageService,
    private stateManagementStorageService: StateManagementStorageService,
    private $state: StateService
  ) { }

  ngOnInit() {
    this.userDetails = {};
    this.teamMemberData = [];
    this.activityMap = [];
    this.rowViewUserData = [];
    this.teamMemberLoaded = false;
    this.fromUserManagement = false;
    this.companyState = this.authService.getUserDetails().company.companyState;
    this.userId = this.authService.getUserDetails().id;
    this.addUserNotEnabled = true;
    this._getUserActivityTypes();
    this._setUsersRowViewStatus();
    this.isCollapsed = true;

    if ((this.iconClicked !== undefined && this.iconClicked !== null) ||
      (this.managerDetails === undefined || this.managerDetails === null || _.isEmpty(this.managerDetails))) {
      this.getAllUsers();
    } else if (this.fromManagerCard) {
      this.managerDetails = _.cloneDeep(this.managerDetails);
      this.currentManager = this.managerDetails;
      this.currentManagerChange.emit(this.currentManager);
      this._getLoggedInUserDetails((data) => {
        this.userDetailsCopy = _.cloneDeep(data);
        this.userDetails = data;
        this.managerDetails.canDrillDown = true;
        this.fromUserManagement = true;
        this.viewReportees(this.managerDetails);
        this.managerDetails = null;
      });
    } else {
      this.managerDetails = _.cloneDeep(this.managerDetails);
      if (this.managerDetails.roleName === '4dot5Admin' || this.managerDetails.roleName === '4dot5SuperUser') {
        this.getAllUsers();
      } else {
        this.managers = this.storageService.get('managers') || this.managers;
        this.managersChange.emit(this.managers);
        if (this.managers !== null && !this.managers.length) {
          this.getAllUsers();
        } else {
          this.currentManager = this.managerDetails;
          this.currentManagerChange.emit(this.currentManager);
          this._getLoggedInUserDetails((data) => {
            this.userDetailsCopy = _.cloneDeep(data);
            this.userDetails = data;
            this.managerDetails.canDrillDown = true;
            this.fromUserManagement = true;
            this.viewReportees(this.managerDetails);
            this.managerDetails = null;
          });
        }
      }
    }
  }

  _getUserActivityTypes() {
    this.jobService.getActivityTypes((data) => {
      this.activityMap = [];
      data.forEach(val => {
        this.activityMap[val.value] = val.name;
      });
    }, (error) => {
      if (this.authService.isOnline) {
        this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
      }
    });
  }

  _getLoggedInUserDetails(successCallback) {
    this.userService.getLoggedInUserDetails((data) => {
      if (successCallback) {
        successCallback(data);
      }
    }, (error) => {
      if (this.authService.isOnline) {
        this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
      }
    });
  }

  getAllUsers() {
    this.teamMemberLoaded = false;
    this._getLoggedInUserDetails((data) => {
      this.userDetailsCopy = _.cloneDeep(data);
      this.managers = [];
      this.managersChange.emit(this.managers);
      this.userDetails = data;
    });
    if (!this.isUserRowViewActive) {
      this.userService.getAllUsers(this.authService.getUserDetails().company.companyId, (data) => {
        this.teamMemberLoaded = true;
        this.teamMemberData = data.teamMembers;
      }, (error) => {
        this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
      });
    } else {
      this.getAllUsersHierarchy();
    }
  }

  viewReportees(teamMember) {
    this.teamMemberLoaded = false;
    if (teamMember.canDrillDown) {
      this._getReportees(teamMember.userId, (data) => {
        this.currentManager = teamMember;
        this.currentManagerChange.emit(this.currentManager);
        if (this.managers !== null) {
          if (!this.fromUserManagement) {
            if (_.findIndex(this.managers, { userId: teamMember.userId }) === -1) {
              this.managers.push(teamMember);
              this.managersChange.emit(this.managers);
            }
          } else {
            this.fromUserManagement = false;
          }
        } else {
          this.getAllUsers();
        }
        this.teamMemberLoaded = true;
        this.teamMemberData = data;
        this.userDetails = teamMember;
        this.teamMemberData.forEach(user => {
          const managerIndex = _.findIndex(this.managers, { userId: user.userId });
          if (managerIndex !== -1) {
            this.managers.splice(managerIndex, this.managers.length - managerIndex);
            this.storageService.set('managers', this.managers, null);
            this.managersChange.emit(this.managers);
          }
        });
      });
    }
  }

  _getReportees(managerId, successCallback) {
    this.userService.getReportees(managerId, (data) => {
      this.addUserNotEnabled = data.addUserNotEnabled;
      successCallback(data.teamMembers);
    }, (error) => {
      this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
    });
  }

  addUser() {
    this.userService.checkRoleEntityScope((data) => {
      if (data === true) {
        if ((this.managers.length === 0) || (this.managers && data)) {
          this.storageService.set('managers', this.managers, null);
          this.$state.go('missioncontrol.usermanagement',
            { userType: 'applicationUsers', manager: this.userDetails, accessMode: 'create' },
            { reload: true });
        } else {
          this.alertsAndNotificationsService.showBannerMessage(
            "Please define the scope for this role before creating users.", 'danger');
        }
      } else {
        const message = "Please setup the 'Role Scope Definition' for the Company before creating users.";
        this.alertsAndNotificationsService.showCustomConfirm(
          'Setup Role Scope', 'Cancel', 'Setup Role Scope Definition', message, 'warning', 'medium',
          () => { this.$state.go('missioncontrol.roleentityscope', { reload: true }); },
          () => { }
        );
      }
    }, (error) => {
      this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
    });
  }

  deleteUser() {
    // The reload can interrupt the delete modal's close, leaving its scroll lock on the body.
    this.$state.reload().then(() => {
      document.body.classList.remove('modal-open');
      document.body.style.paddingRight = '';
    });
  }

  toggleUserRowView() {
    this.isUserRowViewActive = !this.isUserRowViewActive;
    this.searchTerm = '';
    this.stateManagementStorageService.setScreenState(`user-rowView-${this.userId}`, {
      isUserRowViewActive: this.isUserRowViewActive
    });
    this.getAllUsers();
  }

  getAllUsersHierarchy() {
    const userObject = {
      userId: this.userId,
      loggedInCompanyId: this.authService.getUserDetails().company.companyId
    };
    this.userService.userCache(userObject, () => {
      this.userService.getAllUsersHierarchy(this.authService.getUserDetails().company.companyId, (data) => {
        this.teamMemberLoaded = true;
        if (data && data.teamMembers) {
          this.rowViewUserData = data.teamMembers;
          this.rowViewUserDataOriginal = [...data.teamMembers];
        } else {
          this.rowViewUserData = [];
        }
        this.setCollapsedOrExpanded(this.rowViewUserData, this.isCollapsed);
      }, (error) => {
        this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
      });
    }, (error) => {
      this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
    });
  }

  collapseOrExpand() {
    if (!this.isCollapsed) {
      this.setCollapsedOrExpanded(this.rowViewUserData, true);
    } else {
      this.setCollapsedOrExpanded(this.rowViewUserData, false);
    }
    this.isCollapsed = !this.isCollapsed;
  }

  setCollapsedOrExpanded(user, bool) {
    if (Array.isArray(user)) {
      user.forEach(item => this.setCollapsedOrExpanded(item, bool));
    } else if (typeof user === 'object' && user !== null) {
      user.collapsed = bool;
      for (const key in user) {
        if (user.hasOwnProperty(key)) {
          this.setCollapsedOrExpanded(user[key], bool);
        }
      }
    }
  }

  _setUsersRowViewStatus() {
    const checkIfRowViewActive = this.stateManagementStorageService.getScreenState(`user-rowView-${this.userId}`);
    if (checkIfRowViewActive) {
      this.isUserRowViewActive = checkIfRowViewActive.isUserRowViewActive;
    }
  }

  filterUsers() {
    if (this.isUserRowViewActive) {
      if (this.searchTerm && this.searchTerm !== '') {
        this.isCollapsed = false;
        this.setCollapsedOrExpanded(this.rowViewUserData, false);
        const originalRowViewUsers = _.cloneDeep(this.rowViewUserDataOriginal);
        this.rowViewUserData = this.setRowViewUsers(originalRowViewUsers);
      } else {
        this.isCollapsed = false;
        this.setCollapsedOrExpanded(this.rowViewUserData, true);
        this.rowViewUserData = _.cloneDeep(this.rowViewUserDataOriginal);
      }
    }
  }

  setRowViewUsers(users) {
    return users.filter(user => {
      if (user.fullName.toLowerCase().indexOf(this.searchTerm.toLowerCase()) !== -1 ||
        user.roleDescription.toLowerCase().indexOf(this.searchTerm.toLowerCase()) !== -1) {
        return true;
      }
      if (user.users && user.users.length > 0) {
        user.users = this.setRowViewUsers(user.users);
        return user.users.length > 0;
      }
      return false;
    });
  }

  get filteredTeamMemberData() {
    if (!this.searchTerm) {
      return this.teamMemberData;
    }
    return this.teamMemberData.filter(item => {
      return item.fullName.toLowerCase().indexOf(this.searchTerm.toLowerCase()) !== -1 ||
        item.roleDescription.toLowerCase().indexOf(this.searchTerm.toLowerCase()) !== -1;
    });
  }

  trackByUserId(index, user) {
    return user ? user.userId : index;
  }
}
